import React from 'react';
import styled from 'styled-components';

const Challenges = () => {
    return (
        <ChallengesSection>
            <Container>
                <HeaderContainer>
                    <MainTitle>
                        The Challenge: <br />
                        Shrinking Resources, Rising Needs
                    </MainTitle>
                    <Description>
                        The College of the Muscogee Nation (CMN) is more than an academic
                        institution—it's a cultural cornerstone for tribal leadership,
                        heritage, and community advancement.
                    </Description>
                </HeaderContainer>
                <ChallengeGrid />
            </Container>
            <ConclusionText>
                CMN needed a smarter, scalable solution to support students—without
                losing their unique voice.
            </ConclusionText>
        </ChallengesSection>
    );
};

const ChallengeGrid = () => {
    const topRowChallenges = [
        {
            icon: "https://api.builder.io/api/v1/image/assets/TEMP/ea57f7da8f464df0ec0423ab82b50b0f3a8a4b00?placeholderIfAbsent=true&apiKey=2d7c5855cb2f42a1b4e6163799d67ecc",
            title: "Declining Enrollment & High Melt Rates",
            description: "Many students applied but never completed enrollment."
        },
        {
            icon: "https://api.builder.io/api/v1/image/assets/TEMP/7f877c26c63375a84c5a26cdec8a356e23892ee2?placeholderIfAbsent=true&apiKey=2d7c5855cb2f42a1b4e6163799d67ecc",
            title: "Lack of 24/7 Support",
            description: "First-generation and working students couldn't access help after hours."
        },
        {
            icon: "https://api.builder.io/api/v1/image/assets/TEMP/bcee4665f32b5369d8bd1951e04c2f577558e83b?placeholderIfAbsent=true&apiKey=2d7c5855cb2f42a1b4e6163799d67ecc",
            title: "Static, One-Size-Fits-All Communication",
            description: "Website content lacked personalization or cultural context."
        },
        {
            icon: "https://api.builder.io/api/v1/image/assets/TEMP/bd3fedba09278a6b59a6b37e52ff5d265f21a873?placeholderIfAbsent=true&apiKey=2d7c5855cb2f42a1b4e6163799d67ecc",
            title: "Overburdened Staff",
            description: "Teams were stretched thin, answering repetitive questions with limited bandwidth for personalized support."
        },
        {
            icon: "https://api.builder.io/api/v1/image/assets/TEMP/7f42374a123b3958e4915b89e449df72d0de9dfe?placeholderIfAbsent=true&apiKey=2d7c5855cb2f42a1b4e6163799d67ecc",
            title: "Budget Constraints",
            description: "Scaling services risked compromising CMN's cultural integrity"
        }
    ];

    return (
        <GridContainer>
            <GridRow>
                {topRowChallenges.map((challenge, index) => (
                    <ChallengeCard
                        key={index}
                        icon={challenge.icon}
                        title={challenge.title}
                        description={challenge.description}
                    />
                ))}
            </GridRow>
        </GridContainer>
    );
};

const ChallengeCard = ({ icon, title, description }) => {
    return (
        <Card>
            <CardContent>
                <IconWrapper>
                    <Icon src={icon} alt="" />
                </IconWrapper>
                <Title>{title}</Title>
            </CardContent>
            <Description1>{description}</Description1>
        </Card>
    );
};

const ConclusionText = styled.p`
  color: rgba(59, 58, 68, 1);
  font-size: 20px;
  font-weight: 600;
  font-family: Inter,  sans-serif;
  line-height: 1.4;
  font-style: italic; 
  letter-spacing: -0.2px;
  text-align: center;
  margin: 24px 0 0 0;

  @media (max-width: 991px) {
    max-width: 100%;
  }
`;


const Card = styled.article`
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 4px 4px 4px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  height: 200px;
  width: 312px;
  flex-direction: column;
  align-items: stretch;
  text-align: center;
  justify-content: start;
 
  padding: 24px 24px 42px;
  border: 1px solid rgba(241, 237, 252, 1);

  @media (max-width: 991px) {
    padding: 10px 20px;
    height: auto;
  }
`;

const CardContent = styled.div`
  display: flex;
  max-width: 100%;
  // width: 312px;
  flex-direction: column;
  align-items: center;
  justify-content: start;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 54px;
  border-radius: 0px 0px 0px 0px;
`;

const Title = styled.h3`
  color: #1c1b1f;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.2px;
  line-height: 28px;
  margin: 16px 0 0 0;
`;

const Description1 = styled.p`
  color: #64636a;
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: -0.08px;
  margin: 16px 0 0 0;
  text-align: center;
`;


const GridContainer = styled.div`
  display: flex;
  margin-top: 60px;
  flex-direction: column;
  align-items: center; /* Centers children horizontally in column layout */
  justify-content: center; /* Optional: centers vertically if there's extra height */
  margin-left: auto; /* Centers container itself */
  margin-right: auto;

  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 40px;
  }
  @media (max-width: 640px) {
    width: 80%;
  }
`;


const GridRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 20px;
  justify-content: center; /* center cards */
  flex-wrap: wrap;

  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const BottomRow = styled.div`
  display: flex;
  margin-top: 30px;
  width: 740px;
  max-width: 100%;
  align-items: center;
  gap: 21px;
  justify-content: center; /* center cards */
  flex-wrap: wrap;
`;



const HeaderContainer = styled.header`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: start;

  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const MainTitle = styled.h1`
  color: #1c1b1f;
  font-size: 40px;
  font-weight: 700;
  font-family: Inter,  sans-serif;
  line-height: 58px;
  letter-spacing: -0.48px;
  width: 864px;
  margin: 0;

  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 28px;
    line-height: 34px;
  }
`;

const Description = styled.p`
  color: #3b3a44;
  font-size: 16px;
  font-weight: 500;
  font-family: Inter,  sans-serif;
  line-height: 26px;
  letter-spacing: -0.08px;
  margin: 16px 0 0 0;
  width: 806px;

  @media (max-width: 991px) {
    max-width: 100%;
  }
`;


const ChallengesSection = styled.section`
  font-family: Inter,  sans-serif;
  padding: 40px 10px 20px;
`;

const Container = styled.div`
  width: 100%;

  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

export default Challenges;
